module.exports = __webpack_public_path__ + "img/cfte.15296779.png";